import React from "react";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "theme";

import { RouterProvider } from "react-router-dom";
import routes from "routes";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import "mixins/chartjs";
import "mixins/validate";
import "react-perfect-scrollbar/dist/css/styles.css";
import "assets/scss/main.scss";

function App() {
  return (
    <div>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <RouterProvider router={routes} />
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
